import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import { withStyles } from '@material-ui/core/styles';

import Info, { Detail, Item, Metric } from '../../Info';
import { startEditAdmin } from '../../../store/actions/admin';

const styles = theme => ({
  root: {
    minWidth: '250px',
  },
  section: {
    marginTop: theme.spacing.unit*2,
    marginBottom: theme.spacing.unit*2,
    display: 'flex',
    flexDirection: 'column',
  },
  heading: {
    marginTop: theme.spacing.unit*2,
    marginBottom: theme.spacing.unit*2,
    textAlign: 'center',
  }
});


const BidsSide = ({ editorState, startEditAdmin }) => {
  return(
    <Info
      title="Information Panel"
      actions ={[
        {
          value: "Close",
          handleAction: () => startEditAdmin({bid: null}),
        },
        {
          value: "Preview",
          color: "primary",
        }
      ]}>
      <Item>
        <Detail
          title= {editorState.title}
          sections = {editorState.sections}
        />
      </Item>
      <Item>
        <Metric type="horizontal" label="Quote Points Earned" value="21" />
      </Item>
    </Info>
  );
};

const mapStateToProps = (state) => ({
  editorState: state.bidEditorState._currentState,
});

const mapDispatchToProps = (dispatch) => ({
  startEditAdmin: (bid) => dispatch(startEditAdmin(bid)),
});


export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(BidsSide);



// WEBPACK FOOTER //
// ./src/components/admin/Bids/BidsSide.jsx